<button
  mat-stroked-button
  [matMenuTriggerFor]="matMenuTriggerFor"
  matTooltip="Filtrar y buscar datos"
  style=" color: var(--primary-color);"
  class="button-filtrar"
>
<mat-icon style="color: var(--primary-color);">filter_alt</mat-icon>Filtrar
</button>
